<template>
	<div class="container pb_0">
		<div class="main">
			<p class="text_t type1">{{ $t('rtr_personal-request-deposit.text1') }}</p>
			<p class="text_n">{{ $t('rtr_personal-request-deposit.text2') }}</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.asset_send') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box border_r_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white">
							{{ $t('rtr_personal-request-deposit.text3') }}
						</p>
						<p class="text_n fc_white">
							{{ $t('rtr_personal-request-deposit.text4') }}
						</p>
					</div>
				</div>

				<div class="box_type_02 mt_120">
					<p class="text_t tac mb_50">
						{{ $t('rtr_personal-request-deposit.text5') }}
					</p>
					<div class="white_box_wrap">
						<div class="white_box left mr_20">
							<p class="text_t mb_30">
								{{ $t('rtr_personal-request-deposit.text6') }}<br />{{
									$t('rtr_personal-request-deposit.text7')
								}}
							</p>
							<p class="text_n">
								{{ $t('rtr_personal-request-deposit.text8') }}<br />
								{{ $t('rtr_personal-request-deposit.text9') }}
							</p>
						</div>
						<div class="white_box right">
							<p class="text_t mb_30">
								{{ $t('rtr_personal-request-deposit.text10') }}<br />
								{{ $t('rtr_personal-request-deposit.text11') }}
							</p>
							<p class="text_n">
								{{ $t('rtr_personal-request-deposit.text12') }}<br />
								{{ $t('rtr_personal-request-deposit.text13') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Deposit',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
